import HighchartsReact from  'highcharts-react-official';

const Graph = ({ options, highcharts, type, update }) => <HighchartsReact
  highcharts={highcharts}
  constructorType={type}
  options={options}
  immutable = { update }
/>

export default Graph;